import React, { useEffect, useState } from 'react'
import { Link } from 'gatsby'
import { Stack } from 'react-bootstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faShoppingCart, faTruckFast, faCreditCard, faCheck } from '@fortawesome/free-solid-svg-icons'
import { useLocation } from '@reach/router'

import './progress.scss'

const getActiveClass = (active, value) => {
  return active.startsWith(value) ? 'progress-item active' : 'progress-item'
}

export const Progress = () => {
  const [active, setActive] = useState('/cart')
  const { pathname } = useLocation()

  useEffect(() => {
    setActive(pathname)
  }, [pathname])

  return (
    <Stack className="progress-container" direction='horizontal' gap={7}>
      <Link to="/cart" className={getActiveClass(active, '/cart')}>
        <h5>
          <FontAwesomeIcon icon={faShoppingCart} />
          Cart
        </h5>
      </Link>
      <Link className={getActiveClass(active, '/checkout/shipping')}>
        <h5>
          <FontAwesomeIcon icon={faTruckFast} />
          Shipping
        </h5>
      </Link>
      <Link className={getActiveClass(active, '/checkout/payment')}>
        <h5>
          <FontAwesomeIcon icon={faCreditCard} />
          Payment
        </h5>
      </Link>
      <Link className={getActiveClass(active, '/checkout/complete')}>
        <h5>
          <FontAwesomeIcon icon={faCheck} />
          Complete
        </h5>
      </Link>
    </Stack>
  )
}